export const FORMTAGGABLE_CONTINUE_JOB = 'STEP_JOB_CONTINUE';
export const FORMTAGGABLE_NORMAL = 'STEP_NORMAL';
